import { english } from "./english";
import { french } from "./french";
import { german } from "./german";
import { spanish } from "./spanish";
export const constants = {
    en: english,
    fr: french,
    es: spanish,
    de: german
}